/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowCapsule = createReactComponent("arrow-capsule", "IconArrowCapsule", [
  ["path", { d: "M18 15a6 6 0 1 1 -12 0v-6a6 6 0 1 1 12 0v2", key: "svg-0" }],
  ["path", { d: "M15 8l3 3l3 -3", key: "svg-1" }]
]);

export { IconArrowCapsule as default };
//# sourceMappingURL=IconArrowCapsule.js.map
